<div class="padding-b-70">
   <div class="contentBox">
      <ul class="brand-details-list team-list font-16 line-25">
         <li>
            <div class="">
               <div class="brand-head flex hr-space-between align-top margin-b-20">
                  <div class="">
                     <div class="flex margin-b-15 wow fadeInUp"
                          data-wow-duration="500ms" data-wow-delay="50ms">
                        <div class="icon brand-icon">
                           <img src="assets/images/everstone.png" alt="">
                        </div>
                     </div>
                     <!--                     <div class="font-15 light-color proximaNovaSb">Group ONE Holdings</div>-->
                  </div>
                  <div class="font-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="100ms">
                     <a href="https://www.everstonecapital.com" target="_blank" class="highlight-color proximaNovaSb">
                        https://www.everstonecapital.com
                     </a>
                  </div>
               </div>
               <div class="">
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     The Everstone Group is a leading private equity and real estate investment firm focused on
                     supporting the growth aspirations of entrepreneurs, corporations and asset owners across India and
                     Southeast Asia.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                       Founded in 2006 by Atul Kapur and Sameer Sain, Everstone has since emerged as a market leader. With a
                       large institutional platform and a team of over 400+ experienced professionals based in Singapore,
                       India (Mumbai, Delhi, Bengaluru), Dubai, New York and Mauritius, the firm manages assets in excess of US$7
                       billion across private equity, climate impact, logistics, digital, and venture capital.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Having invested in and developed over 50 million square feet of retail and industrial real estate
                     across India, Everstone is one of the top real estate developers in the country today. And with a
                     strong culture of accountability, shared responsibility and transparency, Everstone takes the lead
                     when investing in the businesses of tomorrow.
                  </div>
                  <div class=" wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Mission Holdings is the largest external shareholder of the Everstone Group, and has co-invested with Everstone Group
                     in some leading franchises for South and South East Asia such as Burger King India.
                  </div>
               </div>
            </div>
         </li>
         <li>
            <div class="person-pic">
               <div class="icon pic margin-b-20 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/AtulKapur.jpg" alt="">
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  <div class="font-17 proximaNovaSb">Atul Kapur</div>
                  <div class="font-14 light-color proximaNovaSb">Co-founder and CIO</div>
               </div>
            </div>
            <div class="person-details line-25">
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Atul Kapur co-founded the Everstone Group and currently serves as the Chief Investment Officer. Based
                  in Singapore, he divides his time between all the Everstone offices to successfully oversee
                  investments in each location.
               </div>
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Before the foundation of Everstone in 2006, Atul spent 12 years at Goldman Sachs where he was a
                  Managing Director in the Principal Strategies Group, based out of London. Prior to this, Atul worked
                  in the Principal Investment Area group of Goldman Sachs in both Asia and Europe, deploying the Goldman
                  Sachs Capital Partners family of funds.
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Atul holds a Bachelor of Commerce from the University of Delhi and is a qualified Chartered
                  Accountant.
               </div>
            </div>
         </li>
         <li>
            <div class="person-pic">
               <div class="icon pic margin-b-20 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/SameerSain.jpg" alt="">
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  <div class="font-17 proximaNovaSb">Sameer Sain</div>
                  <div class="font-14 light-color proximaNovaSb">Co-founder and CEO</div>
               </div>
            </div>
            <div class="person-details line-25">
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Sameer Sain co-founded the Everstone Group in 2006 and currently serves as the Chief Executive Officer
                  for Everstone Capital Asia, based out of Singapore. He is actively involved in managing the firm and
                  overseeing the business in each location, dividing his time between all the Everstone offices across
                  multiple regions.
               </div>
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Before the foundation of Everstone, Sameer spent 11 years at Goldman Sachs, where he was a Managing
                  Director in the Investment Management Division and held the position of Head of Institutional Wealth
                  Management and the Special Investments Group (International). Prior to his appointment as Managing
                  Director, he spent eight years managing public market portfolios for Goldman Sachs clients, investing
                  globally across multiple asset classes.
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Sameer holds a Bachelor of Commerce from the University of Mumbai, a Bachelor of Business
                  Administration from the University of Massachusetts and a Master of Business Administration from
                  Cornell University.
               </div>
            </div>
         </li>
      </ul>
   </div>
</div>
